import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import FileSystem from "components/FileSystem";

import * as ajax from "helpers/ajax";
import styles from "./index.module.css";

import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import HorizontalBarChart from "examples/Charts/BarCharts/HorizontalBarChart";
import {toEuropeanDate, toPrice } from "helpers/functions.js"



export default class OrdiniCommessa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,

            chartData: []
        };
    }

    componentDidMount = () => {
        this.calculateChartData()
    }

    calculateChartData = () => {
        if (!this.state.data.fc_ordini) { return null }

        let chartData = [];
        this.state.data.fc_ordini.map((el) => {
            let i = chartData.findIndex(e => e.label === el.entity.name);

            if (i > -1) {
                chartData[i].price += parseInt(el.amount_gross);
            } else {
                chartData.push({
                    label: el.entity.name,
                    price: parseInt(el.amount_gross)
                })
            }
        })

        this.setState({chartData:chartData})
    }


    renderRigaOrdine = (el, index) => {
        return (
            <tr key={"ordine-"+index}>                           
                <td><MDTypography variant="caption" fontWeight="medium">{el.entity.name}</MDTypography></td>
                <td><MDTypography variant="caption" fontWeight="medium">{el.description}</MDTypography></td>
                <td style={{ width: "10%" }}><MDTypography variant="caption" fontWeight="medium">{toEuropeanDate(el.date)}</MDTypography></td>
                <td><MDTypography variant="caption" fontWeight="medium">{toPrice((el.amount_gross).toFixed(2))}</MDTypography></td>
            </tr>
            )
    }

    render() {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={this.state.data.nome + " - Ordini"}
                    backButton={this.props.backFunction}
                />

                <Grid container>
                    <Grid item xs={12} m={1}>
                <VerticalBarChart
                    icon={{ color: "info", component: "leaderboard" }}
                    title="Ordini per azienda"
                    description="Elenco ordini raggrupati per azienda"
                    chart={{
                        labels: this.state.chartData.map((el) => el.label),
                        datasets: [{
                            label: "totale",
                            color: "info",
                            data: this.state.chartData.map((el) => el.price),
                        }],
                    }}
                        />
                        </Grid>
                </Grid>

                <Grid container>
                    <Grid item xs={12}>
                        <MDBox sx={{ backgroundColor: "white!important", flex: 1, maxHeight: "70vh", overflow: "auto" }} p={3} m={1} borderRadius="lg" shadow="lg" >
                            <table className={styles.tableOrdini}>
                                <thead>
                                    <tr>
                                        <td>FORNITORE</td>
                                        <td>OPERATORE</td>
                                        <td>DATA</td>
                                        <td>IMPORTO</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(this.state.data.fc_ordini) ?
                                        this.state.data.fc_ordini.map((el, index) => { return this.renderRigaOrdine(el, index) })
                                        : null
                                    }
                                </tbody>
                            </table>
                        </MDBox>
                    </Grid>
                </Grid>


            </DashboardLayout>
        )
    }
}


